import "./polyfills";
import "./embed/EmbedController";

require("./react/Root");
